function getDocHeight(doc) {
    doc = doc || document;
    var body = doc.body, html = doc.documentElement;
    var height = Math.max( body.scrollHeight, body.offsetHeight, 
        html.clientHeight, html.scrollHeight, html.offsetHeight );
    return height;
}

function setIframeHeight(iframe) {
    var doc = iframe.contentDocument? iframe.contentDocument: 
        iframe.contentWindow.document;
        console.log(doc);

    iframe.style.visibility = 'hidden';
    iframe.style.height = "10px"; // reset to minimal height ...
    // IE opt. for bing/msn needs a bit added or scrollbar appears
    iframe.style.height = getDocHeight( doc ) + 4 + "px";
    iframe.style.visibility = 'visible';
}

function resizeIFrameToFitContent( iFrame ) {

    iFrame.width  = iFrame.contentWindow.document.body.scrollWidth;
    iFrame.height = iFrame.contentWindow.document.body.scrollHeight;
}

document.addEventListener('DOMContentLoaded', () => {
	if (document.querySelector('.hero-carousel')) {
		const heroCarousels = Array.from(document.querySelectorAll('.hero-carousel'));

		heroCarousels.forEach((carousel) => {
			tns({
				container: carousel,
				items: 2,
				slideBy: 1,
				autoplay: true,
				gutter: 40,
				fixedWidth: 270,
				nav: true,
				navPosition: 'bottom',
				controls: false,
				autoplayTimeout: 7000,
			});
		});
	}

	if (document.querySelector('.quote-slider-js')) {
		const quoteCarousels = Array.from(document.querySelectorAll('.quote-slider-js'));

		quoteCarousels.forEach((carousel) => {
			tns({
				container: carousel,
				items: 1,
				slideBy: 1,
				autoplay: true,
				nav: true,
				navPosition: 'bottom',
				controls: false,
				autoplayTimeout: 7000,
			});
		});
	}

	if (document.querySelector('.hero-iframe-js')) {
		const iframes = Array.from(document.querySelectorAll('.hero-iframe-js'));

		setTimeout(function(){ 
        	iframes.forEach((iframe) => {
				console.log(iframe);
				resizeIFrameToFitContent( iframe );
			})
        }, 3000);
		
	}
});
